import {createFeature, createReducer, on} from '@ngrx/store';
import {AppLayoutType} from '../../services/app-layout';
import {AppLayoutActions} from './app-layout.actions';

export interface AppState {
	layout: AppLayoutType | null;
}

export const initialState: AppState = {
	layout: null,
};

export const appFeature = createFeature({
	name: 'app',
	reducer: createReducer(
		initialState,
		on(AppLayoutActions.setAppLayout, (state, {layout}) => ({...state, layout})),
	)
});
